import { Box, Stack, Typography } from "@mui/material";
import { FC, useContext } from "react";
import { cityPageStoreAddressSX } from "../../StoreLocator/styles/SideList/autoComplete";
import { Linkable } from "@/components/blocks/Linkable";
import { ContentContext } from "@/data/context/content";
import { useStoreLocatorCityPage } from "@/data/Content/StoreLocatorCityPage";
import { LatLng } from "@/data/types/Store";
import { useLocalization } from "@/data/Localization";
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

export const StoreDetailsDisplay: FC = () => {
    const {
        goToStoreInMap,
        stores:cityStores,
        storeHours
    } = useContext(ContentContext) as ReturnType<typeof useStoreLocatorCityPage> & {
        goToStoreInMap:(latLon: LatLng) => void,
        storeHours:Record<string, string>
    }
    const storeLocatorNLS = useLocalization('StoreLocator');
    const storeStockNLS = useLocalization('StoreStock');
    return cityStores?.length>0 ? (
        cityStores?.map(store=>
            <Box sx={cityPageStoreAddressSX} pb={2} mt={2}>
                <Stack direction="row" justifyContent="space-between" alignItems="center" py={1} >
                    <Box>
                        <Box onClick={() => goToStoreInMap(store.coordinates)}>
                            <Typography variant = "miniBody1">{store.storeName}</Typography>
                            <Typography variant = "miniBody1">{store.storeFullAddress}</Typography>
                            <Typography variant = "miniBody1">{store.postalCode}{store.city}</Typography>
                            {storeHours && storeHours[store.physicalStoreName] && storeHours[store.physicalStoreName] !== 'Gesloten'?
                                <Typography variant = "miniBody1" sx={{ color: '#368632;' }}>{storeLocatorNLS.storeStreetOpenTodayFromTo.t({ from: storeHours[store?.physicalStoreName].replace('-', ' tot ') })} </Typography>
                                :
                                <Typography variant = "miniBody1" color="#ff914d">{storeStockNLS.StoreClosedToday.t()}</Typography>
                            }
                        </Box>
                        <Linkable href={store.storePageURL} type="link">
                            <Stack direction="row" alignItems='center' columnGap={1}>
                                <Typography variant = "miniBody1" color='#69baf8'>{storeLocatorNLS.storeStreetGoToStore.t()} </Typography>
                                <KeyboardDoubleArrowRightIcon sx={{ fontSize: 24, color:'#69baf8' }} />
                            </Stack>
                        </Linkable>
                    </Box>
                </Stack>
            </Box>
        )
    ):null;
}